/*
  紹介コード入力欄の動き（CEO 依頼・2026-08-02）

  やること2つだけ。
    1. 入力されたコードを隠し properties[_kb_coupon] へ写す（注文に証跡を残す）
    2. 「適用する」で Shopify の /discount/<コード> を通す

  【当社でコードの真偽を判定しない】
    有効判定は Shopify が持っている。こちらで別に判定すると必ずずれる。
    ずれた結果「使えます」と出して使えないほうが、何も言わないより悪い。

  【値引き後の価格を出さない】
    OPS-003。商品ページで確定的な割引後価格は出せない。
    出すなら App Proxy でコードを検証してからになる（未実装）。
*/
(function () {
  'use strict';

  /** 英数字とハイフン・アンダースコアだけ通す。全角は半角へ寄せる */
  function normalize(raw) {
    return raw
      .normalize('NFKC')       // 全角英数字 → 半角
      .toUpperCase()
      .replace(/[^A-Z0-9_-]/g, '')
      .slice(0, 40);
  }

  function init(root) {
    var input = root.querySelector('[data-kb-coupon-input]');
    var button = root.querySelector('[data-kb-coupon-apply]');
    var property = root.querySelector('[data-kb-coupon-property]');
    var note = root.querySelector('[data-kb-coupon-note]');
    if (!input || !button) return;

    // 入力のたびに整えて、隠しフィールドへ写す。
    // カートに入れた時点で、適用の成否によらず「入力されていた」事実が残る
    input.addEventListener('input', function () {
      var pos = input.selectionStart;
      var cleaned = normalize(input.value);
      if (cleaned !== input.value) {
        input.value = cleaned;
        // 途中の文字を消したときにカーソルが末尾へ飛ぶのを抑える
        try { input.setSelectionRange(pos, pos); } catch (e) { /* 一部の型で不可 */ }
      }
      if (property) property.value = cleaned;
      button.disabled = cleaned === '';
    });

    function apply() {
      var code = normalize(input.value);
      if (code === '') {
        input.focus();
        return;
      }
      if (property) property.value = code;
      if (note) {
        note.textContent = 'コードを確認しています…';
        note.classList.remove('kb-coupon__note--on');
      }
      button.disabled = true;

      // Shopify 標準の経路。ここで検証され、有効ならセッションへ載る。
      // 戻り先を今の商品ページにして、続けてカートへ進めるようにする。
      var back = root.getAttribute('data-product-url') || window.location.pathname;
      window.location.href = '/discount/' + encodeURIComponent(code)
        + '?redirect=' + encodeURIComponent(back + '?kb_coupon=' + encodeURIComponent(code));
    }

    button.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) {
      // Enter で商品フォームが送信され、そのままカートへ入るのを止める
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
    });

    // 戻ってきたとき: 入力を復元する。
    // **「適用されました」とは書かない。** 実際に効いたかはカートが答える
    var back = new URLSearchParams(window.location.search).get('kb_coupon');
    if (back) {
      var code = normalize(back);
      input.value = code;
      if (property) property.value = code;
      button.disabled = code === '';
    } else {
      button.disabled = input.value === '';
    }
  }

  function boot() {
    document.querySelectorAll('[data-kb-coupon]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマがバリアント切替で商品情報を差し替えたときに、付け直す
  document.addEventListener('shopify:section:load', boot);
})();
